// extracted by mini-css-extract-plugin
export default {"arcard":"ARCard_arcard__V9XvG"};